import * as z from "zod";

const AeoPromptResponseDetailSchema_ = z.object({
  model: z.string(),
  timestamp: z.string(),
  content: z.string(),
  contentMarkdown: z.string().nullable(),
});

export const AeoPromptResponseDetailSchema: z.ZodType<AeoPromptResponseDetailSchema> =
  AeoPromptResponseDetailSchema_;
export interface AeoPromptResponseDetailSchema
  extends z.infer<typeof AeoPromptResponseDetailSchema_> {}

export const getAeoPromptResponseDetail = {
  name: "getAeoPromptResponseDetail" as const,
  input: z.object({ promptResponseId: z.bigint() }),
  output: AeoPromptResponseDetailSchema,
};
